/**
 * @generated SignedSource<<446e0cffe472bd02e5b99502678b603b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationCategoryRoute_organization$data = {
  readonly id: any;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationCategoryContent_organization">;
  readonly " $fragmentType": "IntegrationCategoryRoute_organization";
};
export type IntegrationCategoryRoute_organization$key = {
  readonly " $data"?: IntegrationCategoryRoute_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"IntegrationCategoryRoute_organization">;
};

import IntegrationCategoryRouteRefetchQuery_graphql from './IntegrationCategoryRouteRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": IntegrationCategoryRouteRefetchQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "IntegrationCategoryRoute_organization",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "IntegrationCategoryContent_organization"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "GraphQLOrganization",
  "abstractKey": null
};

(node as any).hash = "c0156b798bc140c9b22068a7df22b39f";

export default node;
